export const buildTrendChartData = (trendStats, timeRange) => {
  const current = timeRange === "daily"
    ? trendStats?.daily
    : trendStats?.weekly;

  return {
    labels: current?.labels || [],
    datasets: [
      {
        label: timeRange === "daily" ? "Login Harian" : "Login Mingguan",
        data: current?.data || [],
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };
};
